import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home/Home';
import ExploreActivities from './pages/ExploreActivities/ExploreActivities';
import Configurator from './pages/Configurator/Configurator';
import About from './pages/About/About';
import FinishBuild from './pages/FinishBuild/FinishBuild';
import Contact from './pages/Contact/Contact';
import Models from './pages/Models/Models';
import ModelDetail from './pages/ModelDetail/ModelDetail';
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/BlogPost';
import BookShowcase from './pages/BookShowcase/BookShowcase';
import Gallery from './pages/Gallery/Gallery';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import TermsOfUse from './pages/Legal/TermsOfUse';
import CookiePolicy from './pages/Legal/CookiePolicy';
import CookieBanner from './components/CookieBanner/CookieBanner';
import usePageTracking from './usePageTracking';
import './App.css';

function AppRoutes() {
  usePageTracking();
  return (
    <>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explore-activities" element={<ExploreActivities />} />
        <Route path="/configurator" element={<Configurator />} />
        <Route path="/about" element={<About />} />
        <Route path="/finish-build" element={<Navigate to="/configurator" replace />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book-showcase" element={<BookShowcase />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/models" element={<Models />} />
        <Route path="/models/:key" element={<ModelDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}

export default App;
